<template>
  <div class="flex w-full flex-col gap-1 py-2 font-Spectral md:py-4">
    <span class="text-base font-semibold leading-6 text-stone-700">Time of Day</span>
    <div class="flex cursor-pointer flex-wrap gap-2">
      <button
        v-for="option in optionsWithSelected"
        :key="option.value"
        class="flex flex-1 cursor-pointer flex-col items-start justify-center rounded border-[0.5px] px-4 py-2"
        :class="[option.isSelected ? 'border-gold3 bg-beige1 text-gold1' : 'border-gray1 bg-white text-gray2 md:hover:bg-beige2']"
        @click="toggleTimeOfDay(option.value)"
      >
        <span class="text-left text-base font-normal leading-5" :class="option.isSelected ? 'text-gold1' : 'text-gray2'">
          {{ option.label }}
        </span>
        <span class="text-left text-xs font-normal leading-3" :class="option.isSelected ? 'text-gold1' : 'text-gray2'">
          {{ option.detail }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TimeOfDayValue, TimeRange } from '@/wabunka-src/common/components/stateful/TimeOfDayPicker/types';
import { useTimeOfDay } from '@/wabunka-src/common/composables/general/useTimeOfDay/useTimeOfDay';

interface Props {
  defaultSelect?: TimeOfDayValue[];
  onSelectionChange?: (timeOfDay: Set<TimeOfDayValue>) => void;
  onTimeRangeChange?: (timeRange: TimeRange | null) => void;
}

const props = withDefaults(defineProps<Props>(), {
  defaultSelect: () => [],
  onSelectionChange: undefined,
  onTimeRangeChange: undefined,
});

const { selectedTimeOfDay, toggleTimeOfDay, timeOfDayOptions } = useTimeOfDay({
  defaultSelect: props.defaultSelect,
  onSelectionChange: props.onSelectionChange,
  onTimeRangeChange: props.onTimeRangeChange,
});

const optionsWithSelected = computed(() =>
  timeOfDayOptions.map((option) => ({
    ...option,
    isSelected: selectedTimeOfDay.value.has(option.value),
  })),
);
</script>
